/**
 * Google Drive API service utilities
 */

/**
 * List all folders in user's Google Drive
 * @param {string} token - Google OAuth access token
 * @returns {Promise<Array>} Array of folder objects with id and name
 */
export async function listDriveFolders(token) {
  try {
    const response = await fetch(
      "https://www.googleapis.com/drive/v3/files?q=mimeType='application/vnd.google-apps.folder' and trashed=false&fields=files(id,name)",
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (!response.ok) {
      throw new Error("Unable to load folders. Please try again.");
    }

    const data = await response.json();
    return data.files || [];
  } catch (err) {
    console.error("Error fetching Drive folders:", err);
    throw err;
  }
}

/**
 * Share a specific folder with another user and send notification email
 * @param {string} token - Google OAuth access token
 * @param {string} folderId - Google Drive folder ID
 * @param {string} email - Email address to share with
 * @returns {Promise<Object>} Sharing result object
 */
export async function shareFolder(token, folderId, email) {
  try {
    const endpoint = `https://www.googleapis.com/drive/v3/files/${folderId}/permissions?sendNotificationEmail=true&supportsAllDrives=true`;
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        role: "writer",
        type: "user",
        emailAddress: email,
      }),
    });

    if (!response.ok) {
      throw new Error("Unable to share folder. Please try again.");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error sharing folder:", error);
    throw error;
  }
}
